module.exports = __webpack_public_path__ + "static/media/shop-position-marker.55fdd1d0.png";